import './Loader.css'

const Loader = () => {
    return(
        <div className='Loader'>
            <div class="spinner"></div>
        </div>
    )
}

export default Loader;